module.exports = __webpack_public_path__ + "static/media/logo.885a1535.svg";